export const TIMER = "fade/startTimer";

export const MODAL_OPEN = "ImageModal";
